import { Component, EventEmitter, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-date-nav",
  templateUrl: "./date-nav.component.html",
  styleUrls: ["./date-nav.component.scss"],
  host: { class: "date-nav" },
})
export class DateNavComponent implements OnInit {
  @Output() viewPrevious = new EventEmitter<null>();
  @Output() viewToday = new EventEmitter<null>();
  @Output() viewNext = new EventEmitter<null>();

  constructor() {}

  ngOnInit() {}

  prev() {
    this.viewPrevious.emit();
  }
  today() {
    this.viewToday.emit();
  }
  next() {
    this.viewNext.emit();
  }
}
